module.exports = __webpack_public_path__ + "static/media/fastplaybtn.38e28688.mp3";